import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const HotelBoxTitle = styled.div(
  ({theme}) => css`
    /* Force display mode when this component is rendered as an "<a />" */
    display: block;
    text-decoration: none;
    flex-direction: row;
    align-items: center;
    color: ${theme.colors.contentPrimary};

    ${theme.respondUpTo(
      'lg',
      css`
        ${theme.typography.labelMediumBold}
      `
    )}

    ${theme.respondTo(
      'lg',
      css`
        ${theme.typography.labelLargeBold}
      `
    )}
  `
);
